var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('barcodeScanner',{attrs:{"texts":_vm.texts,"height":_vm.readerHeight,"width":_vm.readerWidth,"camera-time-out":_vm.cameraTimeOut,"max-product-count":_vm.maxProductCount,"endpoint":_vm.searchEndpoint}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }